/**
 * Modelos prontos (Mermaid flowchart) para o elemento flowchart-widget.
 */
import { DEFAULT_MERMAID_FLOWCHART } from './flowchartWidgetUtils';

export const MERMAID_FLOWCHART_PRESETS = [
  {
    id: 'simple-decision',
    i18nKey: 'flowchartPresetSimpleDecision',
    source: DEFAULT_MERMAID_FLOWCHART,
  },
  {
    id: 'linear-lr',
    i18nKey: 'flowchartPresetLinearLr',
    source: `flowchart LR
    A([Pedido]) --> B([Pagamento])
    B --> C([Preparar envio])
    C --> D([Entrega])
    D --> E([Concluído])`,
  },
  {
    id: 'course-module',
    i18nKey: 'flowchartPresetCourseModule',
    source: `flowchart TD
    START([Início do módulo]) --> L1[Videoaula 1]
    L1 --> Q1{Avaliação}
    Q1 -->|Aprovado| L2[Videoaula 2]
    Q1 -->|Repetir| L1
    L2 --> END([Módulo concluído])`,
  },
  {
    id: 'support-ticket',
    i18nKey: 'flowchartPresetSupportTicket',
    source: `flowchart TD
    T[Chamado aberto] --> C{Tipo}
    C -->|Técnico| N1[Nível 1]
    C -->|Pedagógico| N2[Mentor]
    N1 --> R{Resolvido?}
    R -->|Sim| F[Fechado]
    R -->|Não| E[Escalação]
    N2 --> F
    E --> F`,
  },
  {
    id: 'styled-nodes',
    i18nKey: 'flowchartPresetStyledNodes',
    source: `flowchart TD
    A([Início])
    B[Processo]
    C{Decisão}
    D((Resultado))
    E>Erro]
    A --> B
    B --> C
    C -->|ok| D
    C -->|falha| E`,
  },
];
